import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
const MenuPage = () => {
  const [activeCategory, setActiveCategory] = useState('Breakfast');
  return <div className="bg-gradient-to-b from-amber-50 to-amber-100 min-h-screen w-full pt-24 pb-16 px-6" data-id="element-684">
      <div className="container mx-auto max-w-5xl" data-id="element-685">
        <div className="text-center mb-12" data-id="element-686">
          <div className="inline-block mb-4 px-6 py-2 bg-amber-200 text-amber-800 rounded-full font-futuristic" data-id="element-687">
            Culinary Experience
          </div>
          <h1 className="text-4xl md:text-5xl font-futuristic font-bold mb-4 relative inline-block" data-id="element-688">
            Our Menu
            <SparklesIcon size={24} className="absolute -top-4 -right-8 text-amber-500" data-id="element-689" />
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-690">
            Thoughtfully crafted dishes that delight the senses and nourish the
            soul
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mb-12" data-id="element-691">
          {['Breakfast', 'Lunch', 'Coffee & Drinks', 'Desserts'].map(category => <MenuCategory key={category} title={category} icon={getCategoryIcon(category)} active={activeCategory === category} onClick={() => setActiveCategory(category)} data-id="element-692" />)}
        </div>
        <div className="mb-16" data-id="element-693">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-694">
            <h2 className="text-3xl font-futuristic font-semibold mb-8 text-center" data-id="element-695">
              {activeCategory}
            </h2>
            <div className="glass-card rounded-lg shadow-lg p-8" data-id="element-696">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-697">
                {getMenuItems(activeCategory).map((item, index) => <motion.div key={item.name} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.3,
                delay: index * 0.1
              }} data-id="element-698">
                    <MenuItem name={item.name} description={item.description} price={item.price} tags={item.tags} data-id="element-699" />
                  </motion.div>)}
              </div>
            </div>
          </motion.div>
        </div>
        <p className="text-center text-gray-600 mb-8" data-id="element-700">
          This is a preview of our menu. Please visit us to see our complete
          offerings including daily specials.
        </p>
        <div className="glass-card rounded-lg p-8 max-w-2xl mx-auto" data-id="element-701">
          <h3 className="text-xl font-futuristic font-semibold mb-4" data-id="element-702">
            Dietary Accommodations
          </h3>
          <p className="text-gray-700 mb-6" data-id="element-703">
            We're happy to accommodate various dietary needs and sensory
            preferences. Please inform our staff about any allergies or specific
            requirements.
          </p>
          <div className="flex flex-wrap gap-3" data-id="element-704">
            <DietaryTag label="Vegan Options" data-id="element-705" />
            <DietaryTag label="Gluten-Free" data-id="element-706" />
            <DietaryTag label="Low Sugar" data-id="element-707" />
            <DietaryTag label="Soft Textures" data-id="element-708" />
            <DietaryTag label="Crunchy Options" data-id="element-709" />
            <DietaryTag label="Dairy-Free" data-id="element-710" />
          </div>
        </div>
      </div>
    </div>;
};
const MenuCategory = ({
  title,
  icon,
  active,
  onClick
}) => <div className={`${active ? 'glass-card shadow-lg border-2 border-green-500' : 'bg-white/80 hover:bg-white/90'} rounded-lg p-6 text-center cursor-pointer transition duration-300 hover-lift`} onClick={onClick} data-id="element-711">
    <div className="text-3xl mb-2" data-id="element-712">{icon}</div>
    <h3 className="text-xl font-futuristic font-semibold" data-id="element-713">{title}</h3>
  </div>;
const MenuItem = ({
  name,
  description,
  price,
  tags = []
}) => <div className="border-b border-gray-100 pb-6 h-full flex flex-col" data-id="element-714">
    <div className="flex justify-between items-start mb-2" data-id="element-715">
      <h4 className="text-lg font-futuristic font-medium" data-id="element-716">{name}</h4>
      <span className="font-futuristic font-medium text-green-700 bg-green-100 px-3 py-1 rounded-full text-sm" data-id="element-717">
        {price}
      </span>
    </div>
    <p className="text-gray-600 text-sm mb-auto" data-id="element-718">{description}</p>
    {tags.length > 0 && <div className="flex flex-wrap gap-1 mt-3" data-id="element-719">
        {tags.map((tag, index) => <span key={index} className="inline-block bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded-full font-futuristic" data-id="element-720">
            {tag}
          </span>)}
      </div>}
  </div>;
const DietaryTag = ({
  label
}) => <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-futuristic" data-id="element-721">
    {label}
  </span>;
const getCategoryIcon = category => {
  switch (category) {
    case 'Breakfast':
      return '☕';
    case 'Lunch':
      return '🍽️';
    case 'Coffee & Drinks':
      return '🥤';
    case 'Desserts':
      return '🍰';
    default:
      return '🍴';
  }
};
const getMenuItems = category => {
  switch (category) {
    case 'Breakfast':
      return [{
        name: 'Avocado Toast',
        description: 'Crushed avocado on artisanal sourdough with cherry tomatoes and microgreens',
        price: 'KSh 650',
        tags: ['Vegan', 'Textured']
      }, {
        name: 'Kenyan Breakfast Bowl',
        description: 'Traditional uji with seasonal fruits, honey, and toasted nuts',
        price: 'KSh 550',
        tags: ['Gluten-Free Option', 'Smooth']
      }, {
        name: 'Eggs Benedict',
        description: 'Poached eggs on English muffin with hollandaise sauce and smoked salmon',
        price: 'KSh 850',
        tags: ['Protein-Rich']
      }, {
        name: 'Pancake Stack',
        description: 'Fluffy pancakes with maple syrup, fresh berries, and whipped cream',
        price: 'KSh 750',
        tags: ['Sweet', 'Soft']
      }, {
        name: 'Granola Parfait',
        description: 'Layers of yogurt, house-made granola, and fruit compote',
        price: 'KSh 600',
        tags: ['Crunchy', 'Low Sugar Option']
      }, {
        name: 'Breakfast Burrito',
        description: 'Scrambled eggs, black beans, avocado, and cheese in a warm tortilla',
        price: 'KSh 700',
        tags: ['Protein-Rich', 'Wrapped']
      }];
    case 'Lunch':
      return [{
        name: 'Grilled Chicken Salad',
        description: 'Marinated chicken breast on a bed of mixed greens with avocado and citrus vinaigrette',
        price: 'KSh 850',
        tags: ['Protein-Rich', 'Fresh']
      }, {
        name: 'Signature Burger',
        description: 'Grass-fed beef patty with caramelized onions, aged cheddar, and special sauce on a brioche bun',
        price: 'KSh 950',
        tags: ['Hearty', 'House Specialty']
      }, {
        name: 'Vegetable Curry',
        description: 'Seasonal vegetables in a fragrant coconut curry with steamed rice',
        price: 'KSh 750',
        tags: ['Vegan', 'Spicy Option']
      }, {
        name: 'Fish Tacos',
        description: 'Grilled tilapia with slaw, avocado cream, and mango salsa in soft corn tortillas',
        price: 'KSh 800',
        tags: ['Seafood', 'Gluten-Free Option']
      }];
    case 'Coffee & Drinks':
      return [{
        name: 'Specialty Coffee',
        description: 'Single-origin Kenyan coffee prepared using your choice of method: pour-over, French press, or espresso',
        price: 'KSh 350',
        tags: ['Local', 'Customizable']
      }, {
        name: 'Sensory Latte',
        description: 'Our signature espresso with steamed milk and your choice of flavor infusion',
        price: 'KSh 400',
        tags: ['Creamy', 'Aromatic']
      }, {
        name: 'Fruit Smoothie',
        description: 'Blended seasonal fruits with yogurt or plant-based milk',
        price: 'KSh 450',
        tags: ['Refreshing', 'Dairy-Free Option']
      }, {
        name: 'Herbal Infusion',
        description: 'Calming blend of local herbs and flowers, served hot or iced',
        price: 'KSh 300',
        tags: ['Caffeine-Free', 'Soothing']
      }];
    case 'Desserts':
      return [{
        name: 'Chocolate Lava Cake',
        description: 'Warm chocolate cake with a molten center, served with vanilla ice cream',
        price: 'KSh 550',
        tags: ['Warm', 'Rich']
      }, {
        name: 'Fruit Crumble',
        description: 'Seasonal fruit baked with a crunchy oat topping, served with custard',
        price: 'KSh 500',
        tags: ['Textured', 'Comforting']
      }, {
        name: 'Cheesecake',
        description: 'Creamy cheesecake with passion fruit coulis',
        price: 'KSh 600',
        tags: ['Smooth', 'Tangy']
      }, {
        name: 'Sorbet Selection',
        description: 'Trio of house-made fruit sorbets',
        price: 'KSh 400',
        tags: ['Vegan', 'Refreshing']
      }];
    default:
      return [];
  }
};
export default MenuPage;